import { Redirect, Stack, usePathname } from 'expo-router'
import { useAppSession } from '@/src/contexts/AppSessionContext'
import { resolvePaywallRouteDecision } from '@/src/features/paywall/utils/paywall-route'

function isWithinPostPaymentOnboardingPath(pathname: string): boolean {
  return (
    pathname === '/post-payment-onboarding' ||
    pathname.startsWith('/post-payment-onboarding/')
  )
}

export default function PurchaseLayout() {
  const pathname = usePathname()
  const { hasPurchased, requiresPostPaymentOnboarding } = useAppSession()
  const routeDecision = resolvePaywallRouteDecision({
    hasPurchased,
    requiresPostPaymentOnboarding,
  })

  if (
    routeDecision === 'post-payment-onboarding' &&
    !isWithinPostPaymentOnboardingPath(pathname)
  ) {
    return <Redirect href="/post-payment-onboarding" />
  }

  if (routeDecision === 'home') {
    return <Redirect href="/" />
  }

  return (
    <Stack
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="voucher/redeem" />
    </Stack>
  )
}
